import React from "react";
import DocUploadUser from "./DocUploadUsers/DocUploadUser";
import DocViewUser from "./DocViewUsers/DocViewUser";
import Subcategory from "./Subcategory/Subcategory"

import { withApollo } from "react-apollo";



class ProjectFolderDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      category: props.category,
      activeMenu: "Subcategory",
    };
    this.changeMenu = this.changeMenu.bind(this);
  }

  changeMenu(e, menu) {
    e.preventDefault();
    this.setState({ activeMenu: menu });
  }

  componentDidMount(){
  }

  componentDidUpdate(prevProps) {
    if (prevProps.category !== this.props.category) {
      this.setState({ category: this.props.category });
    }
  }

  render() {
    const {
      category,
      activeMenu,
    } = this.state;
    return (
      <div className="tab-style-1">
        {Object.keys(this.props.category).length?<div
          className="nav flex-column nav-pills"
          id="v-pills-tab"
          role="tablist"
          aria-orientation="vertical"
        >
            <a 
                className={activeMenu === "Subcategory"? "nav-link active": "nav-link"} 
                id="doc-tab" data-toggle="pill" href="#doc" role="tab" aria-controls="doc" aria-selected="false" 
                onClick={e => {
                    this.changeMenu(e, "Subcategory");
                }}>
                <span>Folder</span>
            </a>
            {/* <a
              className={
                activeMenu === "DocUploadUser" ? "nav-link active" : "nav-link"
              }
              id="serv-tab"
              data-toggle="pill"
              href="#serv"
              role="tab"
              aria-controls="serv"
              aria-selected="true"
              style={{ marginTop: "5px" }}
              onClick={e => {
                this.changeMenu(e, "DocUploadUser");
              }}
            >
              <span>Users(Doc-Upload)</span>
            </a> */}
            {!category.viewByAllUsers ? <a
              className={
                activeMenu === "DocViewUser" ? "nav-link active" : "nav-link"
              }
              id="serv-tab"
              data-toggle="pill"
              href="#serv"
              role="tab"
              aria-controls="serv"
              aria-selected="true"
              style={{ marginTop: "5px" }}
              onClick={e => {
                this.changeMenu(e, "DocViewUser");
              }}
            >
              <span>Users(Doc-View)</span>
            </a>:null}
        </div>:null}
        <div className="tab-content" id="v-pills-tabContent">
        {activeMenu === "Subcategory"  ? (
            <Subcategory
            category={category}
            />
          ) : null}
        {activeMenu === "DocViewUser"  ? (
            <DocViewUser
            category={category}
            />
          ) : null}
          {activeMenu === "DocUploadUser"  ? (
            <DocUploadUser
            category={category}
            />
          ) : null}
        </div>
      </div>
    );
  }
}

export default withApollo(ProjectFolderDetails);
